import { render, staticRenderFns } from "./GoodTypeSwitch.vue?vue&type=template&id=ce79130c&scoped=true&"
import script from "./GoodTypeSwitch.vue?vue&type=script&lang=js&"
export * from "./GoodTypeSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce79130c",
  null
  
)

export default component.exports